import React from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import DeleteIcon from "../assets/images/Delete.svg";
import { useTheme } from "@mui/material/styles";

export default function CancelRetentionModal({
  open,
  handleClose,
  handleConfirm,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "34px",
            overflow: "hidden",
            m: isMobile ? 2 : 0,
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            padding: isMobile ? "20px" : "32px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              width: isMobile ? "60px" : "70px",
              height: isMobile ? "60px" : "70px",
              borderRadius: "50%",
              backgroundColor: "#F1F7FA",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <img
              src={DeleteIcon}
              alt="Delete Icon"
              style={{ width: "60%", height: "60%" }}
            />
          </Box>

          {/* Title */}
          <Typography
            color="#2A4876"
            variant="h6"
            fontWeight="bold"
            gutterBottom
            sx={{
              fontSize: isMobile ? "16px" : "20px",
              lineHeight: isMobile ? "22px" : "26px",
            }}
          >
            Are you sure you want to Cancel your <br />
            Content Retention Plan?
          </Typography>

          {/* Description */}
          <Typography
            color="#2A4876"
            fontWeight={400}
            sx={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "22px",
              marginTop: "8px",
            }}
          >
            Once the plan expires, your content will not be visible to the Echo
            community any more.
          </Typography>

          {/* Buttons */}
          <Box
            mt={3}
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            justifyContent="center"
            alignItems="center"
            gap={2}
            width="100%"
          >
            <Button
              onClick={handleConfirm}
              fullWidth={isMobile}
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#AAB6C8",
                color: "#2A4876",
                fontWeight: "bold",
                padding: "12px 24px",
                "&:hover": { backgroundColor: "#C4CED8" },
              }}
            >
              Cancel Plan
            </Button>
            <Button
              onClick={handleClose}
              fullWidth={isMobile}
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#2A4876",
                color: "#FFFFFF",
                fontWeight: "bold",
                padding: "12px 24px",
                "&:hover": { backgroundColor: "#002A5C" },
              }}
            >
              Don&apos;t Cancel Plan
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
